import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import ReservationButtonList from '../ReservationButtonList';
import Link from '../Link';
import Icon from '../Icon';
import { getTranslation } from '../../providers/TranslationProvider';

import './PlatinumVenueShift.scss';

export default function PlatinumVenueShift({
  Analytics,
  amexLogoUrl,
  context,
  reservations,
  onReservationSelect,
  activeNotifications,
  clearFilterButton,
  featureRecaptcha,
  serviceTypeId,
  serviceTypeName,
  venueId,
  venueCity,
  venueName,
  centurionNyValue,
  centNyTableTypesArr,
  partySize,
  headline,
  title,
  desc,
  viewAllLabel,
  viewAllLink,
}) {
  const hasInventory = (reservations && reservations?.length > 0);

  const renderDescription = () => {
    const termsCopy = getTranslation({ translationKey: 'platinum_terms_link_text', fallback: 'Terms Apply' });
    const ariaText = getTranslation({ translationKey: 'platinum_terms_aria_text', fallback: 'Opens in new window.' });

    return (
      <>
        {desc}
        {' '}
        <Link href={`${viewAllLink}#terms`} target="_blank">
          {termsCopy}
          <span className="sr-only">{ariaText}</span>
        </Link>
      </>
    );
  };

  return (
    <div className="PlatinumVenueShift">
      <div className="PlatinumVenueShift__container">
        <div className="PlatinumVenueShift__header">
          <Icon
            iconClass="card-image"
            url={amexLogoUrl}
          />
          <div className="PlatinumVenueShift__header-text">
            <div className="PlatinumVenueShift__content-container">
              <div>
                <div className="PlatinumVenueShift__head">
                  {headline}
                </div>
                <h2 className="PlatinumVenueShift__title">
                  {title}
                </h2>
              </div>
            </div>
            <div className="PlatinumVenueShift__desc-desktop">
              {renderDescription()}
            </div>
          </div>
        </div>
        <div className="PlatinumVenueShift__desc-mobile">
          {renderDescription()}
        </div>
        <div className={cx({
          'PlatinumVenueShift__shift-no_inventory': !hasInventory,
          PlatinumVenueShift__shift: hasInventory,
        })}
        >
          <ReservationButtonList
            Analytics={Analytics}
            reservations={reservations}
            onReservationSelect={onReservationSelect}
            activeNotifications={activeNotifications}
            className={cx({ ShiftInventory__shift__slots: hasInventory })}
            clearFilterButton={clearFilterButton}
            context={context}
            featureRecaptcha={featureRecaptcha}
            serviceTypeId={serviceTypeId}
            serviceTypeName={serviceTypeName}
            venueId={venueId}
            venueCity={venueCity}
            venueName={venueName}
            centurionNyValue={centurionNyValue}
            centNyTableTypesArr={centNyTableTypesArr}
            partySize={partySize}
          />
          <div className="PlatinumVenueShift__cta">
            <Link href={viewAllLink} target="_blank" variant="button-secondary">
              {viewAllLabel}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

PlatinumVenueShift.propTypes = {
  Analytics: PropTypes.shape({}).isRequired,
  amexLogoUrl: PropTypes.string,
  activeNotifications: PropTypes.shape([]),
  centNyTableTypesArr: PropTypes.shape([]),
  centurionNyValue: PropTypes.string,
  clearFilterButton: PropTypes.func.isRequired,
  context: PropTypes.string,
  featureRecaptcha: PropTypes.bool,
  onReservationSelect: PropTypes.func.isRequired,
  partySize: PropTypes.string,
  reservations: PropTypes.shape([]),
  serviceTypeId: PropTypes.string,
  serviceTypeName: PropTypes.string,
  venueCity: PropTypes.string,
  venueId: PropTypes.string,
  venueName: PropTypes.string,
  viewAllLabel: PropTypes.string,
  headline: PropTypes.string,
  title: PropTypes.string,
  desc: PropTypes.string,
  viewAllLink: PropTypes.string,
};

PlatinumVenueShift.defaultProps = {
  activeNotifications: [],
  amexLogoUrl: null,
  centNyTableTypesArr: [],
  centurionNyValue: '',
  context: null,
  featureRecaptcha: undefined,
  partySize: 2,
  reservations: undefined,
  serviceTypeId: undefined,
  serviceTypeName: undefined,
  venueCity: undefined,
  venueId: undefined,
  venueName: undefined,
  viewAllLabel: undefined,
  headline: '',
  title: '',
  desc: '',
  viewAllLink: null,
};
